import { Component, OnInit, EventEmitter, Output,  ViewChild, Input } from '@angular/core';

import { GlobalComponent } from '../../../global/global.component';
import { FilterSettingsModel, GridComponent, QueryCellInfoEventArgs, DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from "@angular/common/http";
import { DataUtil } from '@syncfusion/ej2-data';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { ColumnChangeBO, columnWidth, functionpermission } from '../../list/list.model';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { v4 as uuidv4 } from 'uuid';
import { DatePipe } from '@angular/common';
import { AuthListBO, AuthorizationFilterBo, authpermission, EditDetailsAuthorization, GetImportAuthorizationBo, returnClientAuthorization } from '../client-parent.model';
import { CommonApiService } from 'src/app/commonapiservice';
@Component({
  selector: 'app-client-authorization',
  templateUrl: './client-authorization.component.html',
  styleUrls: ['./client-authorization.component.scss'],

})
export class ClientAuthorizationComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  fp: authpermission = new authpermission();

  AuthorizationImportList: any = [];
  Output: any = "";
  sftpAuthFileName: string = "";
  @Output() EventToEditAuth = new EventEmitter<EditDetailsAuthorization>();
  EditOptions: EditDetailsAuthorization = new EditDetailsAuthorization();
  clientAuthList: returnClientAuthorization[];
  @Input() AuthRelation: AuthorizationFilterBo = new AuthorizationFilterBo;
  @ViewChild('grid') public grid: GridComponent;
  FileURl: any;
  ColumnArray: columnWidth[];
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: string = "00000000-0000-0000-0000-000000000000";
  getImportAuthorizationList: GetImportAuthorizationBo = new GetImportAuthorizationBo();
  arraycol: any = [];
  filterOptions: FilterSettingsModel;
  initialPage: object;
  initialPageAuthStatus: object;
  formatOptions: object;
  public data: Observable<DataStateChangeEventArgs>;
  ListBO: AuthListBO = new AuthListBO();
  AuthorizationTotalColumns:number=17;
  constructor(public CommonAPI: CommonApiService, public datepipe: DatePipe, public toastrService: ToastrService,  public global: GlobalComponent,) {
    this.global.agencyList();
    this.data = CommonAPI;
  }
  ngOnInit(): void {
    this.clearGridLocalStorage();
    this.getpermission()
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
   // let pag = JSON.parse(this.global.globalColumn.column)[0].Authorization.Pagesize;
   this.initialPage = { pageSizes: ['10', '20', '50', '100', '250'], pageSize: 10 };
    this.ListBO.pageitem = 10;
    this.filterOptions = { type: 'Menu' };
    this.getAuthrization();
  }
  //============================Add client======================//
  AddAuthorization(modalType: string, data) {
    if (modalType == 'new') {
      this.EditOptions.isEdit = true;
      this.EditOptions.type = 'new';
      this.EditOptions.ClientId = this.global.clientId
      this.EditOptions.AuthorizationId = "00000000-0000-0000-0000-000000000000";
  
     
     
      this.EventToEditAuth.emit(this.EditOptions);

    }
    if (modalType == 'edit') {
      this.EditOptions.AuthorizationId = data.id;
      this.EditOptions.type = 'edit';
      this.EditOptions.isEdit = true;
      this.EditOptions.ClientId = this.global.clientId
      this.EditOptions.AuthorizationData = data;
      this.EventToEditAuth.emit(this.EditOptions);
    }
    if (modalType == 'delete') {

      this.EditOptions.AuthorizationId = data.id;
      this.EditOptions.type = 'delete';
      this.EditOptions.ClientId = this.global.clientId
      this.EditOptions.isEdit = true;
      this.EditOptions.AuthorizationData = data;
      this.EventToEditAuth.emit(this.EditOptions);
    }
    if (modalType == 'addfrequency') {
      this.EditOptions.AuthorizationId = data.id;
      this.EditOptions.type = 'addfrequency';
      this.EditOptions.ClientId = this.global.clientId
      this.EditOptions.isEdit = true;
      this.EditOptions.AuthorizationData = data;
      this.EventToEditAuth.emit(this.EditOptions);

    }
  }
  getAuthrization() {
    this.ListBO.state = this.AuthRelation.TypeFilter
    this.ListBO.clientId = this.global.clientId;
    let count = 0;
    let url = "api/ClientAuthorization/GetClientAuthorizationList"
    let responseData =
    {
      result: "listcli",
      count: "totalCount",
    }
    this.CommonAPI.outputValues(url, this.ListBO, responseData, "");
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      data.result.forEach(element => {
        let val2 = element.totalhrsparDay?.toString().split('.');
        if (val2.length == 1) {
          element.totalUnitsperday = val2[0] + " hr " + "0 Min";
        }
        else {
          let vals2 = 0 + "." + val2[val2.length - 1];
          element.totalUnitsperday = val2[0] + " hr " + (parseFloat(vals2) * 60).toString().split('.')[0] + "Min";
        }

        let valweek = element.totalhrsperWeek?.toString().split('.');
        if (valweek.length == 1) {
          element.totalUnitsperweek = valweek[0] + " hr " + "0 Min";
        }
        else {
          let valsweek = 0 + "." + valweek[valweek.length - 1];
          element.totalUnitsperweek = valweek[0] + " hr " + (parseFloat(valsweek) * 60).toString().split('.')[0] + "Min";
        }
        let val1 = element.remaininghrsparDay?.toString().split('.');
        if (val1.length == 1) {
          element.remainunitparDay = val1[0] + " hr " + "0 Min";
        }
        else {
          let vals1 = 0 + "." + val1[val1.length - 1];
          element.remainunitparDay = val1[0] + " hr " + (parseFloat(vals1) * 60).toString().split('.')[0] + "Min";
        }

        let valweeks = element.remaininghrsperWeek?.toString().split('.');
        if (valweeks.length == 1) {
          element.remainunitperWeek = valweeks[0] + " hr " + "0 Min";
        }
        else {
          let valsweeks = 0 + "." + valweeks[valweeks.length - 1];
          element.remainunitperWeek = valweeks[0] + " hr " + (parseFloat(valsweeks) * 60).toString().split('.')[0] + "Min";
        }

      });
      count++;

      this.clientAuthList = DataUtil.parse.parseJson(data.result);

      if (data != null && data != undefined && count == 1) {

      //  this.getColumnwidth();
      }

    })
  }
  //============================== Tooltip =========================================================//
  headerCellInfo(args) {

    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);

  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',


        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  getpermission() {
    let params = new URLSearchParams();
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    params.append("pagecode", "Client");
    // params.append("roleId", this.global.roleId);
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.fp = data;
      }
      else {
        this.fp = new authpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new authpermission();
      })
  }
  // ==============================================================================
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].Authorization.Columns;
    let showcol = this.arraycol[0].Authorization.ShowColumns;
    let hidecol = this.arraycol[0].Authorization.HideColumns;
    this.grid.showColumns(showcol);
    this.grid.hideColumns(hidecol);
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.grid.pageSettings.pageSize = this.arraycol[0].Authorization.Pagesize;
    this.ColumnArray.forEach(element => {
      if (element.column == 'Start Date') {
        const column = this.grid.getColumnByField('startDate');
        column.headerText = element.column;
        column.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'End Date') {
        const column1 = this.grid.getColumnByField('endDate');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Company Name') {
        const column1 = this.grid.getColumnByField('companyName');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Payor Name') {
        const column1 = this.grid.getColumnByField('payorName');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Insurance Number') {
        const column1 = this.grid.getColumnByField('insuranceNo');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }

      if (element.column == 'Service Agreement#') {
        const column1 = this.grid.getColumnByField('serviceAgreementNo');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Service Code') {
        const column1 = this.grid.getColumnByField('serviceCode');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Description') {
        const column1 = this.grid.getColumnByField('serviceDescription');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      // if (element.column == 'Units/Day Billed') {
      //   const column1 = this.grid.getColumnByField('remainingunitsPerDay'); 
      //   column1.width = element.width;
      //   this.grid.refreshHeader();
      // }
      // if (element.column == 'Units/Week Billed') {
      //   const column1 = this.grid.getColumnByField('remainingUnitsPerWeek'); 
      //   column1.width = element.width;
      //   this.grid.refreshHeader();
      // }
      if (element.column == 'Total units') {

        const column1 = this.grid.getColumnByField('totalUnits');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Units Used') {
        const column1 = this.grid.getColumnByField('unitsUsed');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'AuthorizationImportType') {
        const column1 = this.grid.getColumnByField('authImportType');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      // if (element.column == 'AuthorizationTimesheetImportType') {
      //   const column1 = this.grid.getColumnByField('authUsedTimesheetTypeName');
      //   column1.headerText = element.column;
      //   column1.width = element.width;
      //   this.grid.refreshHeader();
      // }

      // if (element.column == 'Auth Limit') {
      //   const column1 = this.grid.getColumnByField('authLimitType');
      //   column1.headerText = element.column;
      //   column1.width = element.width;
      //   this.grid.refreshHeader();
      // }
      if (element.column == 'Units Remaining') {
        const column1 = this.grid.getColumnByField('unitsRemaining');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Hours Per Week') {
        const column1 = this.grid.getColumnByField('totalUnitsperweek');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Hours Per Day') {
        const column1 = this.grid.getColumnByField('totalUnitsperday');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }

      // if (element.column == 'Remaining Hours') {
      //   const column1 = this.grid.getColumnByField('remaininghours');
      //   column1.headerText = element.column;
      //   column1.width = element.width;
      //   this.grid.refreshHeader();
      // }

      if (element.column == 'Actions') {
        const column2 = this.grid.getColumnByUid('action');
        column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();
      }

















      if (element.column == 'Remaining Hours Per Day Based on LastVisitDate') {
        const column1 = this.grid.getColumnByField('remaingHoursPerDayBasedOnLastVisitDatevalues');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }


      if (element.column == 'Remaining Hours Per Week Based on LastVisitDate') {
        const column1 = this.grid.getColumnByField('remaingHoursPerWeekBasedOnLastVisitDatevalues');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Confirmed Units') {
        const column1 = this.grid.getColumnByField('confirmedUnits');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'UnConfirmed Units') {
        const column1 = this.grid.getColumnByField('unconfirmedUnits');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
    });
  }
  SaveColumnwidth() {
    this.arraycol[0].Authorization.Columns = this.ColumnArray;
    this.arraycol[0].Authorization.Pagesize = this.grid.pageSettings.pageSize;

    this.columnchange.userid = this.global.userID;
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;

    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI
      .saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.getColumnwidth();
      });
  }


  onResize(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      //this.SaveColumnwidth();
    }
  }

  //========================= evnt change =====================================================================//
  public dataStateChange(state): void {
    let val = (state.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ListBO.orderColumn = "companyName";
        this.ListBO.orderType = 'asc';

      }
    }
    if (val == "filtering" && state.action.action != "clearFilter") {
      this.ListBO.field = state.action.currentFilterObject.field;
      this.ListBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListBO.operator = state.action.currentFilterObject.operator;
      this.ListBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (val == "filtering" && state.action.action == "clearFilter") {
        this.ListBO.field = "companyName";
        this.ListBO.matchCase = false;
        this.ListBO.operator = "contains";
        this.ListBO.value = "";
        this.ListBO.type = "string"
        this.ListBO.clientId = this.global.clientId;
      }
    }
    if (val == "paging" && state.action.name == "actionBegin") {
      // if (this.grid.pagerModule.pagerObj.pageSize != this.arraycol[0].Client.Pagesize) {

      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Authorization.Pagesize != state.take) {
          this.arraycol[0].Authorization.Pagesize = state.take
          this.SaveColumnwidth();
          // }

        }

      }

    }
    if (this.ListBO.type == "date") {
      this.ListBO.value = this.global.getDateTimeString(state.action.currentFilterObject.value)
      this.ListBO.field = state.action.currentFilterObject.field;
    }
    this.getAuthrization();
  }

  /////////////////////////////Action Begin ////////////////////////////////////////////////////////


  public onActionComplete(args) {
    this.ListBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.ListBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.ListBO.type = args.columnType
    }
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].Authorization.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });

        });
        this.arraycol[0].Authorization.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });

        });

        if (showarr.length != count1 || hidearr.length != count) {
          this.arraycol[0].Authorization.ShowColumns = showarr;
          this.arraycol[0].Authorization.HideColumns = hidearr;
          this.arraycol[0].Authorization.Pagesize =
            this.grid.pagerModule.pagerObj.pageSize;
          this.SaveColumnwidth();
        }
      }
    }
  }


  getAuthorizationdata() {
    if (this.AuthRelation.TypeFilter == "active") {
      this.ListBO.state = this.AuthRelation.TypeFilter
    }
    else if (this.AuthRelation.TypeFilter == "expired") {
      this.ListBO.state = this.AuthRelation.TypeFilter
    }
    else {
      this.ListBO.state = this.AuthRelation.TypeFilter
    }
    this.getAuthrization();
  }
  getPage() {
    let pag = JSON.parse(this.global.globalColumn.column)[0].AuthorizationImportStatus.Pagesize;
    this.initialPageAuthStatus = { pageSizes: ['10', '15', '20', '50', '100', '250'], pageSize: pag };
  }
  rowDataBound(args) {
    if (args.data.excludeAuth == true) {
      args.row.style.background = '#EDC2A7';
    }
  }

  generateSFTPAuthFile(data) {
    this.sftpAuthFileName = data.sftpAuthFileName;
    let params = new URLSearchParams();
    params.append("SFTPAuthFileId", data.authDetailId);
    let url = "api/SFTPAuthFile/GetSFTPAuthFile?";
    this.CommonAPI.GetFunctionForResponseTypeAsBlob(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      let file = new Blob([data], { type: 'application/pdf' });
      var fileURL = URL.createObjectURL(file);
      this.FileURl = fileURL;
      document.getElementById("openPdfModal").click();
    }
      , (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;
      });
  }
  b64toBlob(b64Data) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: "application/pdf" });
    return blob;
  }
  closePdf() {
    document.getElementById("openPdfModal").click();
  }
  show() {

    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  DownloadPDF() {
    const a = document.createElement('a');
    a.href = this.FileURl;
    a.download = 'Authorization' + this.sftpAuthFileName + uuidv4().replace(/-/g, '') + '.pdf';
    a.click();
  }
   clearGridLocalStorage(): void {
    // Define grid configurations for visits
    const gridConfigs = [
      { localStorageKey: 'gridAuthListGrid', expectedColumns: this.AuthorizationTotalColumns },
    ];
    
    // Use global method for localStorage clearing
    this.global.clearGridIdLocalStorage(gridConfigs);
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
